const operator = {

  '=': (k, v, data) => {
    v = Array.isArray(v) ? v : [v];

    const [first] = v,
          v1 = (first === null) ? String(first) : first;//.toLowerCase();

    const isNull = {
      'null' : true, 'not-null': false
    };

    if(Object.keys(isNull).includes(v1)){
      return (v1 === 'null') ? data === null : data !== null;
    }else{
      return v.filter(v => data === v).length > 0;
    }
  },

  '!': (k, v, data) => {
    v = Array.isArray(v) ? v : [v];

    const [first] = v,
          v1 = (first === null) ? String(first) : first.toLowerCase();

    const isNull = {
      'null' : true, 'not-null': false
    };

    if(Object.keys(isNull).includes(v1)){
      return (v1 === 'null') ? data !== null : data === null;
    }else{
      return v.filter(v => data !== v).length > 0;
    }
  },

  '<': (k, v, data) => {
    v = Array.isArray(v) ? v[0] : v;
    return (isNaN(v) || isNaN(data)) ? false : data < v;
  },

  '>': (k, v, data) => {
    v = Array.isArray(v) ? v[0] : v;
    return (isNaN(v) || isNaN(data)) ? false : data > v;
  },

  '≦':(k, v, data) => {
    v = Array.isArray(v) ? v[0] : v;
    return (isNaN(v) || isNaN(data)) ? false : data <= v;
  },

  '≧':(k, v, data) => {
    v = Array.isArray(v) ? v[0] : v;
    return (isNaN(v) || isNaN(data)) ? false : data >= v;
  },

  '-': (k, v, data) => {

    if(!Array.isArray(v) || isNaN(data)){
      return false;
    }

    const [v1, v2] = v;
    return v1 <= data && data <= v2;
  },

  '*': (k, v, data) => {
    if(Array.isArray(v)){
      return false;
    }
    v = v.replace(/[\\^$.\-+?()[\]{}|]/g, '\\$&').replace(/\*/g, '.*');
    return data.match(new RegExp(`^${v}$`, 's'));
  }

};

module.exports = (split) => {

  const keySplit = split(Object.keys(operator).join(''));

  const filter = {

    where: (data, condition) => {

      return data.filter((v) => {

        const or = condition.filter((ov) => {
          ov = Object.entries(ov);

          const and = ov.filter(([ak, av]) => {
            const [k, op] = keySplit(ak);
            return operator[op](k, av, v[k]);
          });

          return and.length === ov.length;

        });

        return or.length > 0;
      });
    },

    order: (data, condition) => {

      return Object.entries(condition).reduce((o, [k, v]) => {

        v = (v.toLowerCase() !== 'desc') ? true : false;

        return [...o].sort((a, b) => {

          const orderA = (v) ? a[k] : b[k],
                orderB = (v) ? b[k] : a[k];

          if(typeof orderA !== 'string' || typeof orderB !== 'string'){
            return orderA - orderB;
          }

          const upperA = orderA.toUpperCase(),
                upperB = orderB.toUpperCase();

          return (upperA > upperB) ? 1 : (upperA < upperB) ? -1 : 0;
        }); 

      }, data);

    },

    limit: (data, condition) => {

      const [kv] = Object.entries(condition);

      if(!kv){
        return data;
      }

      let [skip, limit] = kv.map(v => (isNaN(v)) ? v : Number(v));

      if(skip === 'all'){
        return data;
      }

      if(skip === 'one'){
        [skip, limit] = [0, 1];
      }

      return data.slice(skip, limit + skip);
    }

  };

  return (object, condition) => {

    const {where: w = null, ...other} = condition,
           where = (w) ? {where: (w.or) ? w.or : [w]} : {};

    return Object.entries({...where, ...other}).reduce((o, [k, v]) => {
      return filter[k](o, v);

    }, object);

  };

};

